import {
  CommonModule,
  isPlatformBrowser,
  NgClass,
  NgFor,
  NgIf,
  NgSwitch,
  NgSwitchCase,
} from '@angular/common'
import { Component, OnDestroy, OnInit, ViewChild, AfterViewInit, ChangeDetectorRef, PLATFORM_ID, Inject, ElementRef, HostListener } from '@angular/core'
import {
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
} from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import { ButtonComponent, KENDO_BUTTONS } from '@progress/kendo-angular-buttons'
import { DatePickerComponent } from '@progress/kendo-angular-dateinputs'
import {
  DialogActionsComponent,
  DialogComponent,
  DialogService,
  DialogTitleBarComponent,
  KENDO_DIALOGS,
  WindowCloseResult,
  WindowComponent,
  WindowRef,
  WindowService,
} from '@progress/kendo-angular-dialog'
import {
  DropDownListComponent,
  KENDO_DROPDOWNS,
} from '@progress/kendo-angular-dropdowns'
import { ExcelExportData } from '@progress/kendo-angular-excel-export'
import {
  CellTemplateDirective,
  ColumnComponent,
  DataBindingDirective,
  ExcelCommandDirective,
  ExcelComponent,
  GridComponent,
  GridToolbarFocusableDirective,
  KENDO_GRID,
  KENDO_GRID_EXCEL_EXPORT,
  KENDO_GRID_PDF_EXPORT,
  ToolbarTemplateDirective,
} from '@progress/kendo-angular-grid'
import { KENDO_INDICATORS } from '@progress/kendo-angular-indicators'
import { KENDO_INPUTS, TextBoxDirective } from '@progress/kendo-angular-inputs'
import { LabelComponent } from '@progress/kendo-angular-label'
import {
  CompositeFilterDescriptor,
  process,
  SortDescriptor,
} from '@progress/kendo-data-query'
import { NgIconComponent, provideIcons } from '@ng-icons/core'
import {
  heroPencil,
  heroFolder,
  heroPencilSquare,
  heroFolderOpen,
  heroChevronDown,
  heroChevronUp,
  heroBookmark,
  heroEye,
  heroMagnifyingGlass,
  heroArchiveBox,
  heroDocument,
  heroXMark,
  heroPrinter,
  heroArrowDownTray,
} from '@ng-icons/heroicons/outline'
import { heroBookmarkSolid } from '@ng-icons/heroicons/solid'
import * as CryptoJS from 'crypto-js'
import { ToastrService } from 'ngx-toastr'
import { Subscription } from 'rxjs'
import { environment } from '../../../environments/environment'
import { DataService } from '../../@theme/services/data.service'
import { InitUserService } from '../../@theme/services/init-user.service'
import { TransactionsServices } from '../../@theme/services/transactions.service'
import { Column } from '../../models/column.model'
import { ClientinfoComponent } from '../ClientInfo/clientinfo.component'
import { ClienttransComponent } from '../ClientInfo/clienttransactions/clienttransaction.component'
import { FilemanagerComponent } from '../FileManager/filemanager.component'
import { Pdfaccountreceipt } from '../pdfSaveas/pdfaccountreceipt'
import { PdfSaveComponent } from '../pdfSaveas/pdfDirective'
import { ClientServices } from './../../@theme/services/clients.service'
import { TransactionViewState } from './../../models/viewState.model'
import { TransactionStateService } from './transaction-state.service'
// Rows fetched for the instant first paint before the full result arrives.
const TRANSACTION_PREVIEW_ROWS = 100

@Component({
  selector: 'gd-transaction-list',
  templateUrl: './transaction-list.component.html',
  styleUrls: ['./transaction-list.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LabelComponent,
    TextBoxDirective,
    NgIf,
    KENDO_DROPDOWNS,
    KENDO_GRID,
    KENDO_INPUTS,
    KENDO_GRID_PDF_EXPORT,
    KENDO_GRID_EXCEL_EXPORT,
    KENDO_INDICATORS,
    KENDO_DIALOGS,
    KENDO_BUTTONS,
    DropDownListComponent,
    DatePickerComponent,
    GridComponent,
    DataBindingDirective,
    ToolbarTemplateDirective,
    ExcelCommandDirective,
    GridToolbarFocusableDirective,
    NgFor,
    ColumnComponent,
    NgSwitch,
    NgSwitchCase,
    CellTemplateDirective,
    NgClass,
    ExcelComponent,
    WindowComponent,
    ClienttransComponent,
    DialogComponent,
    DialogTitleBarComponent,
    PdfSaveComponent,
    DialogActionsComponent,
    ButtonComponent,
    Pdfaccountreceipt,
    NgIconComponent,
  ],
  providers: [
    provideIcons({
      heroEye,
      heroMagnifyingGlass,
      heroArchiveBox,
      heroPencil,
      heroFolder,
      heroPencilSquare,
      heroFolderOpen,
      heroBookmark,
      heroBookmarkSolid,
      heroDocument,
      heroChevronUp,
      heroChevronDown,
      heroXMark,
      heroPrinter,
      heroArrowDownTray,
    }),
  ],
})
export class TransactionListComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('header') accordion
  @ViewChild('grid', { static: false }) grid?: GridComponent
  @ViewChild('gridContainer', { static: false }) gridContainer?: ElementRef
  @ViewChild('searchCard', { static: false }) searchCard?: ElementRef
  
  public gridContainerHeight: number = 500 // Space available above the footer
  // Applied grid height: the rows' natural height, capped at gridContainerHeight.
  public gridHeight: number = 500
  private resizeObserver?: ResizeObserver
  private observedGridTable?: Element
  public dropdownStatusLight = [
    { text: 'Rep Processing Paperwork', value: -2 },
    { text: 'Processing Paperwork ', value: 0 },
    { text: 'Submitted for Review', value: 1 },
  ]
  /*   public group: { field: string }[] = [
      {
        field: "blotterId",
      },
    ]; */
  public columns: Column[] = []
  public openAccountReadOnly = false
  public RepNamInfo: any[] = []
  public blotterComment: number
  public initialPageLoad = true
  public viewallblot = ''
  public branches: any[] = []
  public reps: any[] = []
  public filteredReps: any[] = []
  public statuses: any[] = []
  // Resolved from the status list; the filter defaults to this value.
  public approvedStatusId: number | null = null
  public searchResults: any[] = []
  public hiddenColumns: string[] = []
  public role: string
  public selectdate = false
  public defaultRepItem = { fullName: '-- Select Rep --', repId: null }
  public defaultBranchItem = '-- Select Branch --'
  public defaultStatusItem = { statusTypeDesc: '-- Select Status --', statusTypeId: null }
  public defaultRepCode = '-- Select Rep Code --'
  public repCodeList: any[] = []
  public allRepCodes: any[] = []
  public selectedBlotterId: string
  public selectedBlotterIdNum: number
  public selectedClientId: string
  public selectedRepId: string
  public selectedClientName: string
  public selectedData: any
  public clientIdParam: number | null = null
  public queryString: string
  public hidebyRole: boolean
  public loading = false
  // Full result still downloading behind the preview rows.
  private _loadingAll = false
  public get loadingAll(): boolean {
    return this._loadingAll
  }
  // The loading banner sits above the grid, so the grid resizes when it toggles.
  public set loadingAll(value: boolean) {
    if (this._loadingAll === value) return
    this._loadingAll = value
    this.scheduleGridHeight()
  }
  private fullResultLoaded = false
  // Preview coordination: the full result is always applied after the preview.
  private previewApplied = false
  private previewRowsForMerge: any[] = []
  private pendingFull: any[] | null = null
  // Discriminates responses when searches overlap: only the newest wins.
  private searchSeq = 0
  private destroyed = false

  public viewClientOpen = false
  public fileManagerOpen = false
  public windowRef: WindowRef | null = null
  public formReportOpen = false

  public defaultSelectedStatus: TransactionStatusEnum =
    TransactionStatusEnum.Approved
  public defaultDateRange = 60
  public timeToDayMultiplier = 1000 * 3600 * 24
  public enlarge: string
  public isSearchExpanded = false // Controls search details visibility
  public sort: SortDescriptor[] = [{ field: 'approvedByDate', dir: 'desc' }]
  public filter: CompositeFilterDescriptor = { logic: 'and', filters: [] }
  public searchForm!: FormGroup
  public pageSize = 50
  public highlightTransactionsPendingAlerts = false
  public customTransactionLinkStatus: number
  public defaultSearchFormValues = this.buildDefaultSearchFormValues()
  // coordination flags for initial automatic search
  private loadedPreferences = false
  private loadedViewState = false
  // The Approved status id is resolved from an async lookup. The initial search
  // must not run before it arrives, or it would go out with a null status and
  // the backend would return every status.
  private loadedStatuses = false
  private hasViewState = false
  private initialSearchPerformed = false
  /*   public searchForm: FormGroup = this.formBuilder.group(
      this.defaultSearchFormValues,
    ) */
  public subscription: Subscription = new Subscription()

  //public columns: Column[] = this.dataService.allTransactionColumns

  rowCallback = (row: any) =>
    row.dataItem.alertRep && this.highlightTransactionsPendingAlerts
      ? { highlight: true }
      : null

  showClearFieldsButton = () =>
    [
      'blotterId',
      'clientName',
      'accountName',
      'accountNumber',
      'branchNumber',
      'repId',
      'repCode',
      'statusTypeId',
      'submittedStartDate',
      'submittedEndDate',
      'approvalStartDate',
      'approvalEndDate',
    ].some((c) => !!this.searchForm.controls[c].value)

  constructor(
    private route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private transactionService: TransactionsServices,
    private router: Router,
    //  private iconLibraries: NbIconLibraries,
    private initUserService: InitUserService,
    private toastrService: ToastrService,
    private clientService: ClientServices,
    private dialogService: DialogService,
    private windowService: WindowService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private transactionState: TransactionStateService,
    @Inject(PLATFORM_ID) private platformId: object,
  ) {
    this.searchForm = this.formBuilder.group(this.defaultSearchFormValues)
    this.subscription.add(
      this.route.queryParams.subscribe((params) => {
        if (params['cld']) {
          const paramT = CryptoJS.AES.decrypt(
            params['cld'].trim(),
            environment.securepw.trim(),
          ).toString(CryptoJS.enc.Utf8)
          this.clientIdParam = Number(paramT)
          this.accordion.close()
        }
      }),
    )
    /*    this.iconLibraries.registerFontPack('font-awesome', {
         iconClassPrefix: 'fa',
       }) */
    // viewallblot already initialized
    this.subscription.add(
      this.initUserService.userPreferences$.subscribe((data) => {
        // check if data is an empty object
        if (data && Object.keys(data).length) {
          // Only override default sort if there's a valid sort field in preferences
          if (data.transactionSortField && data.transactionSortDir) {
            this.sort = [
              {
                field: data.transactionSortField,
                dir: data.transactionSortDir,
              },
            ]
          }

          this.pageSize = data.transactionRows
          this.defaultDateRange = data.customTransactionLinkDaysBack
          this.highlightTransactionsPendingAlerts =
            data.highLightTransactionsPendingAlerts
          this.customTransactionLinkStatus = data.customTransactionLinkStatus
          // Status is set by the status lookup (session choice, else Approved);
          // patching it here would overwrite the user's choice.
        }
        this.loadedPreferences = true
        this.maybeInitialSearch()
      }),
    )
    this.subscription.add(
      this.initUserService.transactionViewState$.subscribe((viewState) => {
        if (viewState && Object.keys(viewState).length !== 0) {
          this.hasViewState = true
          this.filter = viewState.filter
          // Only override sort if viewState has valid sort data
          if (viewState.sort && viewState.sort.length > 0) {
            this.sort = viewState.sort
          }
          // Rows-per-page comes from User Preferences (transactionRows), like
          // the Account and Pending screens — do not override it from view
          // state, otherwise the preference never takes effect.
          // Transaction ID and Status are session-scoped and restored by the
          // status lookup, not from this (localStorage) view state.
          this.searchForm.patchValue({
            clientId: viewState.clientId,
            clientName: viewState.clientName,
            accountName: viewState.accountName,
            accountNumber: viewState.accountNumber,
            branchNumber: viewState.selectedBranch || '',
            repId: viewState.selectedRepId || '',
            repCode: viewState.selectedRepCode,
            submittedStartDate: viewState.dateReceivedStartDate,
            submittedEndDate: viewState.dateReceivedEndDate,
            // Approval Begin Date is intentionally not restored/defaulted so it
            // loads empty, matching the End Date's null default.
            approvalStartDate: null,
            approvalEndDate: viewState.approvalEndDate,
          })
        }
        this.loadedViewState = true
        this.maybeInitialSearch()
      }),
    )
    this.allData = this.allData.bind(this)
  }
  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: process(this.searchResults, {
        sort: this.sort,
        filter: this.filter,
      }).data,
    }

    return result
  }
  ngOnInit() {
    this.columns = this.dataService.allTransactionColumns
    this.loadBookmarkIds()
    this.subscription.add(
      this.transactionService.getCurrentRole().subscribe((response) => {
        this.role = response
      }),
    )
    this.subscription.add(
      this.transactionService
        .getTransactionBranchNumbers({})
        .subscribe((response) => {
          this.branches = response
        }),
    )
    this.subscription.add(
      this.transactionService.getTransactionReps({}).subscribe((response) => {
        this.reps = response
        this.filteredReps = this.reps
      }),
    )
    this.subscription.add(
      this.clientService.getRepCodeListAll().subscribe((response) => {
        this.allRepCodes = response
        this.repCodeList = response
      }),
    )
    this.subscription.add(
      this.transactionService
        .getTransactionStatuses({})
        .subscribe({
          next: (response) => {
            // Every status is selectable; Approved is the default. A choice
            // made earlier in this browser session wins while still valid.
            this.statuses = response ?? []
            const approved = this.statuses.find(
              (s: any) =>
                (s.statusTypeDesc ?? '').trim().toLowerCase() === 'approved',
            )
            this.approvedStatusId = approved ? approved.statusTypeId : null
            const saved = this.transactionState.getSessionFilters()
            const savedStatusValid =
              saved?.statusTypeId != null &&
              this.statuses.some((s: any) => s.statusTypeId === saved.statusTypeId)
            // When arriving via a query string (e.g. a deep link with `cld`),
            // default Status to blank so the transaction can be found without a
            // status filter narrowing the results.
            const hasQueryString = this.clientIdParam != null
            this.searchForm.patchValue({
              statusTypeId: hasQueryString
                ? null
                : savedStatusValid
                  ? saved.statusTypeId
                  : this.approvedStatusId,
              blotterId: saved?.blotterId ?? null,
            })
            if (!approved) {
              console.error(
                'No "Approved" entry in the transaction status list; the ' +
                  'Approved default cannot be applied.',
                response,
              )
              this.showStatusLookupError()
            }
            this.loadedStatuses = true
            this.maybeInitialSearch()
          },
          error: (err) => {
            console.error('Failed to load transaction statuses', err)
            this.approvedStatusId = null
            this.showStatusLookupError()
            this.loadedStatuses = true
            this.maybeInitialSearch()
          },
        }),
    )
    this.subscription.add(
      this.transactionService.getHiddenColumns().subscribe((response) => {
        this.hiddenColumns = response
      }),
    )
  }

  ngAfterViewInit(): void {
    // SSR-safe: Force grid to recalculate dimensions after view init
    if (isPlatformBrowser(this.platformId)) {
      // Calculate initial height
      this.scheduleGridHeight()
      
      // Set up ResizeObserver to watch container size changes. The search card
      // is watched too: opening/closing Search Details moves the grid's top edge.
      if (this.gridContainer && typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(() => {
          this.scheduleGridHeight()
        })
        this.resizeObserver.observe(this.gridContainer.nativeElement)
        if (this.searchCard) {
          this.resizeObserver.observe(this.searchCard.nativeElement)
        }
      }
      
      // Initial grid refresh
      setTimeout(() => {
        this.refreshGrid()
      }, 100)
    }
  }

  ngOnDestroy() {
    this.destroyed = true
    // Clean up ResizeObserver
    if (this.resizeObserver && isPlatformBrowser(this.platformId)) {
      this.resizeObserver.disconnect()
    }
    this.subscription.unsubscribe()
    this.saveTransactionViewState()
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.scheduleGridHeight()
  }

  // Recalculates after the current render so layout changes above the grid
  // (search panel, loading banner) are already in place when measured.
  private scheduleGridHeight(): void {
    if (!isPlatformBrowser(this.platformId)) return
    setTimeout(() => {
      if (this.destroyed) return
      const previous = this.gridHeight
      this.calculateGridHeight()
      if (this.gridHeight !== previous) {
        this.cdr.detectChanges()
      }
    })
  }

  private calculateGridHeight(): void {
    if (isPlatformBrowser(this.platformId) && this.gridContainer) {
      // Fill from the grid's top edge down to the fixed app footer (which
      // overlays the bottom of the window), plus a small gap above it so the
      // pager stays visible.
      const footer = document.querySelector('app-footer > div') as HTMLElement | null
      const footerHeight = footer?.offsetHeight || 64
      const bottomGap = footerHeight + 16
      const top = this.gridContainer.nativeElement.getBoundingClientRect().top
      // Ensure minimum height
      this.gridContainerHeight = Math.max(
        300,
        Math.floor(window.innerHeight - top - bottomGap),
      )
      // A definite height (not max-height) keeps the grid's own scrollbar
      // working: short pages shrink to their rows, long pages scroll inside.
      const natural = this.measureNaturalGridHeight()
      this.gridHeight =
        natural === null
          ? this.gridContainerHeight
          : Math.min(this.gridContainerHeight, natural)
    }
  }

  // Height the grid needs to show every row on the current page without
  // scrolling: everything outside the rows area (toolbar, group panel,
  // header, pager, horizontal scrollbar) plus the rows table itself.
  private measureNaturalGridHeight(): number | null {
    const gridEl = this.gridContainer?.nativeElement.querySelector('.k-grid') as HTMLElement | null
    const content = gridEl?.querySelector('.k-grid-content') as HTMLElement | null
    const table = content?.querySelector('table') as HTMLElement | null
    if (!gridEl || !content || !table) return null
    // Re-measure whenever the rows change (paging, page size, filtering, data).
    if (this.resizeObserver && this.observedGridTable !== table) {
      if (this.observedGridTable) this.resizeObserver.unobserve(this.observedGridTable)
      this.resizeObserver.observe(table)
      this.observedGridTable = table
    }
    const chrome = gridEl.offsetHeight - content.clientHeight
    return Math.ceil(chrome + table.offsetHeight)
  }

  public onGridDataBound(): void {
    // Called when grid finishes binding data
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.refreshGrid()
      }, 50)
    }
  }

  private refreshGrid(): void {
    if (this.grid && isPlatformBrowser(this.platformId)) {
      this.cdr.detectChanges()
      // Force scrollbar recalculation by resetting virtual scroll
      setTimeout(() => {
        if (this.grid && (this.searchResults?.length ?? 0) > 0) {
          // Trigger grid internal resize check
          const currentSkip = this.grid.skip || 0
          this.grid.skip = currentSkip
          this.scheduleGridHeight()
        }
      }, 50)
    }
  }

  public onStateChange(states): void {
    this.enlarge = states
  }

  onDateChange(
    changedDate: Date,
    formFieldNameToCheck: string,
    multiplier: number,
  ) {
    if (!changedDate) {
      return
    }
    const dateToCheck = this.searchForm.controls[formFieldNameToCheck]
      .value as Date
    let diff: number

    if (dateToCheck) {
      diff =
        (dateToCheck.getTime() - changedDate.getTime()) /
        this.timeToDayMultiplier
    }

    let newDate: Date
    if (
      !dateToCheck ||
      Math.sign(diff / multiplier) === -1 ||
      diff * multiplier > this.defaultDateRange
    ) {
      newDate = new Date(
        changedDate.getTime() +
        this.defaultDateRange * this.timeToDayMultiplier * multiplier,
      )
      this.searchForm.controls[formFieldNameToCheck].setValue(newDate)
    }
  }

  repChange(event: any) {
    let selectedRepId = null

    if (event && typeof event === 'object') {
      selectedRepId = event.repId !== undefined ? event.repId : event.value
    } else {
      selectedRepId = event
    }

    if (selectedRepId === undefined || selectedRepId === null || selectedRepId === '') {
      selectedRepId = null
    }

    this.searchForm.patchValue({ repId: selectedRepId })

    // If blank selected, restore full rep code list and reset repCode
    if (selectedRepId === null) {
      this.subscription.add(
        this.clientService.getRepCodeListAll().subscribe((response) => {
          this.allRepCodes = response
          this.repCodeList = response
        }),
      )
      this.searchForm.patchValue({ repCode: null })
      return
    }

    // Filter rep codes to only those belonging to the selected rep
    this.subscription.add(
      this.clientService.getRepCodeList({ repId: selectedRepId }).subscribe((response) => {
        this.repCodeList = response
        this.searchForm.patchValue({ repCode: null })
      }),
    )
  }

  repCodeChange(event: any) {
    const selectedRepCode = typeof event === 'object' ? event?.repCode : event
    // If blank/default selected, reset repCode
    if (!selectedRepCode || selectedRepCode === this.defaultRepCode) {
      this.searchForm.patchValue({ repCode: null })
    }
  }

  onPageChange(event: any) {
    if (event.take && event.take !== this.pageSize) {
      this.pageSize = event.take
      this.saveTransactionViewState()
    }
  }

  onSortChange(sort: SortDescriptor[]) {
    this.sort = sort
    this.saveTransactionViewState()
  }

  branchChange(selectedBranchNumber: string) {
    // Handle blank/default selection
    if (!selectedBranchNumber || selectedBranchNumber === ' ' || selectedBranchNumber === this.defaultBranchItem) {
      this.filteredReps = this.reps
      return
    }
    this.filteredReps = this.reps.filter(
      (r) => r.branchNumber === selectedBranchNumber,
    )
  }

  clearFields(fieldNames: string[] = []) {
    if (fieldNames.length) {
      fieldNames.forEach((f) => this.searchForm.controls[f]?.reset())
      return
    }
    this.searchForm.reset()
    // A clear leaves Status blank so results can be pulled by Transaction Id
    // (or any other field) without a status filter narrowing them.
    this.searchForm.patchValue({ statusTypeId: null })
    this.saveSessionFilters()
    this.filteredReps = this.reps
    this.subscription.add(
      this.clientService.getRepCodeListAll().subscribe((response) => {
        this.allRepCodes = response
        this.repCodeList = response
      }),
    )
  }

  resetFields() {
    this.searchForm.reset(this.defaultSearchFormValues)
    // Reset leaves Status blank so results can be pulled by Transaction Id
    // (or any other field) without a status filter narrowing them.
    this.searchForm.patchValue({
      statusTypeId: null,
    })
    this.saveSessionFilters()
    this.filteredReps = this.reps
    this.subscription.add(
      this.clientService.getRepCodeListAll().subscribe((response) => {
        this.allRepCodes = response
        this.repCodeList = response
      }),
    )
  this.getTransactionSearchResults()
  }

  clearFilter(field: string) {
    this.searchForm.controls[field].reset()
  }

  getTransactionSearchResults(clientId: number | null = null) {
    const payload = this.buildSearchPayload(clientId)

    // Newest search wins: every callback below checks it is still the current one.
    const seq = ++this.searchSeq
    this.fullResultLoaded = false
    this.previewApplied = false
    this.previewRowsForMerge = []
    this.pendingFull = null
    this.loading = true
    this.loadingAll = true

    // A filtered search (account, blotter, status, rep code, or date filters)
    // returns a focused set, so it loads in a single request. Rep/branch are
    // ignored because they default from the user's settings, and client-name is
    // excluded so it still uses the two-phase load below.
    if (this.isFilteredSearch(payload)) {
      this.subscription.add(
        this.transactionService.getTransactionResults(payload).subscribe({
          next: (response) => {
            if (this.isStale(seq)) return
            this.fullResultLoaded = true
            this.loadingAll = false
            this.applyResults(response ?? [])
          },
          error: () => {
            if (this.isStale(seq)) return
            this.fullResultLoaded = true
            this.loadingAll = false
            this.loading = false
          },
        }),
      )
      return
    }

    // Two-phase: the preview (capped first page) paints immediately, then the
    // full result loads and appends the remaining rows. Used for the unfiltered
    // "load everything" case.
    this.subscription.add(
      this.transactionService
        .getTransactionResults({
          ...payload,
          Take: TRANSACTION_PREVIEW_ROWS,
        })
        .subscribe({
          next: (response) => {
            // Discard if the full result already won the race - it is a superset.
            if (this.isStale(seq) || this.fullResultLoaded) return
            const preview = response ?? []
            this.applyResults(preview)
            this.previewApplied = true
            this.previewRowsForMerge = preview
            // If the full result arrived first, merge it in now.
            if (this.pendingFull) {
              const full = this.pendingFull
              this.pendingFull = null
              this.mergePreviewAndFull(preview, full)
            }
          },
          error: () => {
            if (this.isStale(seq)) return
            this.previewApplied = true
            this.previewRowsForMerge = []
            if (this.pendingFull) {
              const full = this.pendingFull
              this.pendingFull = null
              this.applyResults(full)
            }
          },
        }),
    )

    this.subscription.add(
      this.transactionService.getTransactionResults(payload).subscribe({
        next: (response) => {
          if (this.isStale(seq)) return
          this.fullResultLoaded = true
          this.loadingAll = false
          const full = response ?? []
          // The full result is a superset of the preview. If it beats the
          // preview back, apply it now instead of parking it: the preview
          // handler bails once fullResultLoaded is set, so a parked result
          // would never be shown (grid stuck loading with data in hand).
          if (!this.previewApplied) {
            this.previewApplied = true
            this.applyResults(full)
            return
          }
          if (this.previewRowsForMerge.length) {
            this.mergePreviewAndFull(this.previewRowsForMerge, full)
          } else {
            this.applyResults(full)
          }
        },
        error: () => {
          if (this.isStale(seq)) return
          this.fullResultLoaded = true
          this.loadingAll = false
          this.loading = false
        },
      }),
    )
  }

  // A search counts as "filtered" (single-hit) when any focused filter is set.
  // RepId/BranchNumber are ignored because they default from the user's settings.
  private isFilteredSearch(payload: any): boolean {
    return (
      !!payload.ClientName ||
      !!payload.AccountName ||
      !!payload.AccountNumber ||
      payload.BlotterId != null ||
      (payload.repCode != null && payload.repCode !== '') ||
      !!payload.SubmittedStartDate ||
      !!payload.SubmittedEndDate ||
      !!payload.ApprovalStartDate ||
      !!payload.ApprovalEndDate
    )
  }

  private isStale(seq: number): boolean {
    return this.destroyed || seq !== this.searchSeq
  }

  private mergePreviewAndFull(previewRows: any[], fullRows: any[]) {
    const seen = new Set(previewRows.map((r) => r.blotterId))
    const appended = fullRows.filter((r) => !seen.has(r.blotterId))
    this.applyResults(previewRows.concat(appended))
  }

  private applyResults(rows: any[]) {
    this.searchResults = rows
    this.applyBookmarkIds()
    this.loading = false
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.refreshGrid()
      }, 150)
    }
  }

  public get hasActiveFilter(): boolean {
    return (this.filter?.filters?.length ?? 0) > 0
  }

  public get previewRowCount(): number {
    return TRANSACTION_PREVIEW_ROWS
  }

  private buildSearchPayload(clientId: number | null = null): any {
    if (clientId) {
      if (this.initialPageLoad) {
        this.clearFields()
        this.initialPageLoad = false
      }
      this.searchForm.patchValue({ clientId })
    }
    const params: any = { ...this.searchForm.value }
    // Remember the searched Status / Transaction ID for this browser session.
    this.saveSessionFilters()
    if (params.accountName) {
      params.accountName = params.accountName
        .replace(/[,\-]/g, ' ')  // Replace commas and hyphens with spaces
        .replace(/\s+/g, ' ')     // Replace multiple spaces with single space
        .trim()
    }

    // Handle repCode - extract first part if it contains spaces, or empty string if null
    params.repCode = this.searchForm.controls['repCode'].value?.split(' ')[0] ?? ''

    // Handle repId - convert null/undefined to 0 for backend
    if (params.repId === null || params.repId === undefined || params.repId === '') {
      params.repId = 0
    }

    // Handle branchNumber - convert blank selection to empty string
    if (params.branchNumber === this.defaultBranchItem) {
      params.branchNumber = ''
    }

    // Handle statusTypeId - convert null/undefined to 0 for backend
    if (params.statusTypeId === null || params.statusTypeId === undefined || params.statusTypeId === '') {
      params.statusTypeId = null
    }

    // Handle clientId - use param or default to 0
    if (params.clientId == null || params.clientId == 0) {
      params.clientId = this.clientIdParam ?? 0
    }

    // Transform camelCase keys to PascalCase to match C# backend model
    return {
      BlotterId: params.blotterId,
      ClientId: params.clientId,
      ClientName: params.clientName,
      AccountName: params.accountName,
      AccountNumber: params.accountNumber,
      BranchNumber: params.branchNumber,
      RepId: params.repId,  // This will now be passed correctly
      repCode: params.repCode,
      StatusTypeId: params.statusTypeId,
      SubmittedStartDate: params.submittedStartDate,
      SubmittedEndDate: params.submittedEndDate,
      ApprovalStartDate: params.approvalStartDate,
      ApprovalEndDate: params.approvalEndDate
    }
  }

  updateBookmark(dataItem: any): void {
    if (dataItem.bookm !== null) {
      this.removeBookmark(dataItem)
    } else {
      this.addBookmark(dataItem)
    }
  }

  // The transaction list API does not return bookmark ids, so pull the user's
  // bookmarks separately and copy the ids onto matching rows (on load + reloads).
  private bookmarkIds = new Map<number, number>()
  private loadBookmarkIds(): void {
    this.subscription.add(
      this.transactionService.getbookmarks().subscribe((rows: any[]) => {
        this.bookmarkIds = new Map(
          (rows ?? [])
            .filter((r) => r?.blotterId != null && r?.bookm != null)
            .map((r) => [r.blotterId, r.bookm] as [number, number]),
        )
        this.applyBookmarkIds()
        this.cdr.detectChanges()
      }),
    )
  }
  private applyBookmarkIds(): void {
    if (!this.searchResults?.length || !this.bookmarkIds.size) {
      return
    }
    this.searchResults.forEach((item) => {
      if (this.bookmarkIds.has(item.blotterId)) {
        item.bookm = this.bookmarkIds.get(item.blotterId)
      }
    })
  }

  /*
  ***********
  BookMark from Grid
  ***********
  */
  addBookmark(dataItem: any) {
    const param = { blotterId: dataItem.blotterId }
    this.transactionService.PostBookMarks(param).subscribe(() => {
      this.toastrService.success('Bookmark was added', 'Success')
      dataItem.bookm = dataItem.blotterId
      // Refresh the real bookmark id so a later remove targets the right record.
      this.loadBookmarkIds()
    })
  }

  /*
  ***********
  BookMark Remove from Grid
  ***********
  */
  removeBookmark(dataItem: any) {
    const param = { bookmarkId: dataItem.bookm }
    this.transactionService.PostBookMarksRemove(param).subscribe(() => {
      this.toastrService.success('Bookmark was removed', 'Success')
      this.bookmarkIds.delete(dataItem.blotterId)
      dataItem.bookm = null
    })
  }

  viewClientInfo(clientId: number) {
    const clientInfoDialogRef = this.dialogService.open({
      title: 'View Client',
      content: ClientinfoComponent,
      maxHeight: '95%',
      width: '850px',
      maxWidth: '95%',
      actions: [{ text: 'Close', themeColor: 'primary' }],
    })

    const clientInfo = clientInfoDialogRef.content.instance
    clientInfo.clientId = clientId
  }

  onSubmit() {
    // Form is always valid since we have no required validators
    // Users can search with any combination of filters including all blank
    this.selectdate = false
    this.getTransactionSearchResults(this.clientIdParam)
  }
  viewTransaction(blotterId: string) {
    this.selectedBlotterId = blotterId
    this.viewClientOpen = true
  }
  EditAccount(clientId: number,
    param,
    paramcli,
    paramrepencode,
    paramclientname,
    paramstatustype,
    paramtransactiontype,
    paramproducttype,
    reviewtransaction,
    accountformreview,
    paramstatetype,
    repIdunencrypt,
    repCodeIdcrypt) {
    this.router.navigate(['/pages/TabsScreen/tab-views'], {
      queryParams: {
        Rview: param,
        Cld: clientId,
        clientId: paramcli,
        rId: paramrepencode,
        cl: paramclientname,
        EditTrans: true,
        statustype: paramstatustype,
        transaction: paramtransactiontype,
        product: paramproducttype,
        reviewtrans: reviewtransaction,
        accountformrvew: accountformreview,
        edittransactionShow: true,
        stateId: paramstatetype,
        repunencrypt: repIdunencrypt,
        repCodeId: repCodeIdcrypt,
      },
    })
  }
  EditTransactions(
    blotID: number,
    clientId: number,
    repId: number,
    repcodeId: number,
    clt: string,
    statustype: number,
    tranactionstype: number,
    producttype: number,
    reviewtransaction: boolean,
    accountformreview: boolean,
    _statustypeId: number, // kept for backwards compatibility (unused)
    _datastatusId: string, // kept for backwards compatibility (unused)
    
  ) {
    const blotterIdEncrypted = this.encryptProperty(blotID.toString())
    const clientIdEncrypted = this.encryptProperty(clientId.toString())
    const repIdEncrypted = this.encryptProperty(repId.toString())
    const repCodeIdEncrypted = this.encryptProperty(repcodeId?.toString())
    const clientNameEncrypted = this.encryptProperty(clt)
    const statusTypeIdEncrypted = this.encryptProperty(statustype.toString())
    const transactionTypeIdEncrypted = this.encryptProperty(tranactionstype.toString())
    const productTypeIdEncrypted = this.encryptProperty(producttype.toString())
    const stateIdEncrypted = this.encryptProperty(_datastatusId)

    if (tranactionstype === 5) {
     this.EditAccount(
        clientId,
        blotterIdEncrypted,
        clientIdEncrypted,
        repIdEncrypted,
        clientNameEncrypted,
        statusTypeIdEncrypted,
        transactionTypeIdEncrypted,
        productTypeIdEncrypted,
        reviewtransaction,
        accountformreview,
        stateIdEncrypted,
        repId,
        repCodeIdEncrypted,
      )
      return
    }
    this.navigateToTabView({
      blotterId: blotID,
      clientId,
      repId,
      clientName: clt,
      statusType: statustype,
      transactionType: tranactionstype,
      productType: producttype,
      reviewTransaction: reviewtransaction,
      accountFormReview: accountformreview,
      repCodeId: repcodeId,
      mode: 'edit',
    })
  }

  ReviewTransactionsview(
    blotID: number,
    clientId: number,
    repId: number,
    clt: string,
    statustype: number,
    tranactionstype: number,
    producttype: number,
    reviewtransaction: boolean,
    accountformreview: boolean,
    _statetype: string,
    repcodeId: number,
  ) {
    this.navigateToTabView({
      blotterId: blotID,
      clientId,
      repId,
      clientName: clt,
      statusType: statustype,
      transactionType: tranactionstype,
      productType: producttype,
      reviewTransaction: reviewtransaction,
      accountFormReview: accountformreview,
      repCodeId: repcodeId,
      mode: 'reviewTransaction',
    })
  }
  private encryptProperty(property: string): string {
    return CryptoJS.AES.encrypt(
      encodeURI(property).trim(),
      environment.securepw.trim(),
    ).toString()
  }

  openForm(data: any) {
    this.RepNamInfo = data
    this.blotterComment = Number(data.blotterId)
    this.openAccountReadOnly = true
  }
  ReviewAccountTransactionsview(
    blotID: number,
    clientId: number,
    repId: number,
    clt: string,
    statustype: number,
    tranactionstype: number,
    producttype: number,
    reviewtransaction: boolean,
    accountformreview: boolean,
    repcodeId: number,
  ) {
    this.navigateToTabView({
      blotterId: blotID,
      clientId,
      repId,
      clientName: clt,
      statusType: statustype,
      transactionType: tranactionstype,
      productType: producttype,
      reviewTransaction: reviewtransaction,
      accountFormReview: accountformreview,
      repCodeId: repcodeId,
      mode: 'reviewAccount',
    })
  }
  viewFiles(
    repId: string,
    clientName: string,
    blotterId: string,
    clientId: string,
    queryString: string,
  ): void {
    // If windowRef is not null, close the window before opening a new one
    if (this.windowRef) this.windowRef.close()

    this.selectedRepId = repId
    this.selectedClientName = clientName
    this.selectedBlotterId = blotterId
    this.selectedClientId = clientId
    this.queryString = queryString

    this.windowRef = this.windowService.open({
      title: 'File Manager',
      content: FilemanagerComponent,
      width: 1000,
      height: 675,
    })

    const fileManager = this.windowRef.content.instance

    fileManager.outputClientId = this.selectedClientId
    fileManager.outputrepId = this.selectedRepId
    fileManager.clientName = this.selectedClientName
    fileManager.outquery = this.queryString
    fileManager.viewallblot = this.viewallblot
    fileManager.blotterId = this.selectedBlotterId

    // Sets windowRef to null when window is closed
    this.windowRef.result.subscribe((result) => {
      if (result instanceof WindowCloseResult) {
        this.windowRef = null
        this.resetSelected()
      }
    })
  }
  onDialogReciptClose() {
    this.openAccountReadOnly = false
  }
  goToAccountFormReview(blotterId: number, clientId: number, repId: number) {
    const param = this.encrypt(blotterId)
    const paramcli = this.encrypt(clientId)
    const paramrepencode = this.encrypt(repId)
    this.router.navigate(['/pages/TabsScreen/tab-views'], {
      queryParams: {
        Rview: param,
        cld: paramcli,
        rId: paramrepencode,
        ReviewShow: true,
      },
    })
  }

  // Uses the row's own status text so the Approval Notice does not depend on
  // the role-filtered status lookup (which can omit Approved for some roles).
  isApproved(dataItem: any): boolean {
    return (dataItem?.statusTypeDesc ?? '').trim().toLowerCase() === 'approved'
  }

  openAccountFormReport(dataItem: any) {
     // console.log(JSON.stringify(dataItem))
    this.selectedData = dataItem
    this.selectedBlotterIdNum = Number(dataItem.blotterId)
    this.formReportOpen = true
  }

  close() {
    this.fileManagerOpen = false
  }

  resetSelected() {
    this.viewClientOpen = false
    this.fileManagerOpen = false
    this.formReportOpen = false
    this.selectedRepId = null
    this.selectedClientName = null
    this.selectedBlotterId = null
    this.selectedClientId = null
    this.queryString = null
    this.selectedData = null
    this.selectedBlotterIdNum = null
  }

  // Status and Transaction ID are kept in sessionStorage so they reset on
  // logout or browser close; the rest of the search lives in view state.
  public saveSessionFilters() {
    // Before the status lookup restores them the controls are still blank;
    // saving then would wipe the stored choice.
    if (!this.loadedStatuses) return
    this.transactionState.setSessionFilters({
      statusTypeId: this.searchForm.controls['statusTypeId'].value ?? null,
      blotterId: this.searchForm.controls['blotterId'].value ?? null,
    })
  }

  private saveTransactionViewState() {
    this.saveSessionFilters()
    const viewState: TransactionViewState = {
      filter: this.filter,
      sort: this.sort,
      // Session-scoped (see saveSessionFilters); not persisted to localStorage.
      transactionId: null,
      clientName: this.searchForm.controls['clientName'].value,
      accountName: this.searchForm.controls['accountName'].value,
      accountNumber: this.searchForm.controls['accountNumber'].value,
      selectedBranch: this.searchForm.controls['branchNumber'].value,
      selectedRepId: this.searchForm.controls['repId'].value,
      selectedRepCode: this.searchForm.controls['repCode'].value?.split(' ')[0],
      selectedStatus: null,
      approvalStartDate: this.searchForm.controls['approvalStartDate'].value,
      approvalEndDate: this.searchForm.controls['approvalEndDate'].value,
      dateReceivedStartDate:
        this.searchForm.controls['submittedStartDate'].value,
      dateReceivedEndDate: this.searchForm.controls['submittedEndDate'].value,
      pageSize: this.pageSize,
    }

    this.initUserService.setTransactionViewState(viewState)
  }

  private encrypt(value: number | string | null | undefined): string {
    if (value == null) return '';
   // console.log(JSON.stringify(value))
    return CryptoJS.AES.encrypt(
      encodeURI(value.toString()).trim(),
      environment.securepw.trim(),
    ).toString()
  }

  private navigateToTabView(options: {
    blotterId: number
    clientId: number
    repId: number
    clientName: string
    statusType: number
    transactionType: number
    productType: number
    reviewTransaction: boolean
    accountFormReview: boolean
    repCodeId: number
    mode: 'edit' | 'reviewTransaction' | 'reviewAccount'
  }) {
    const queryParams: any = {
      Rview: this.encrypt(options.blotterId),
      clientId: this.encrypt(options.clientId),
      rId: this.encrypt(options.repId),
      cl: this.encrypt(options.clientName),
      statustype: this.encrypt(options.statusType),
      transaction: this.encrypt(options.transactionType),
      product: this.encrypt(options.productType),
      reviewtrans: options.reviewTransaction,
      accountformrvew: options.accountFormReview,
      repCodeId: this.encrypt(options.repCodeId),
    }

    switch (options.mode) {
      case 'edit':
        queryParams.EditTrans = true
        queryParams.edittransactionShow = true
        queryParams.accountstatus = options.statusType
        break
      case 'reviewTransaction':
        queryParams.ReviewShow = true
        queryParams.paramAccReview = 'Transaction'
        queryParams.reviewtransShow = true
        break
      case 'reviewAccount':
        queryParams.ReviewShow = true
        queryParams.paramAccReview = 'Accountreview'
        queryParams.accountformShow = true
        // The Transaction tab's account section reads the raw (unencrypted) ids -
        // addAccounts reads Cld, accounttransaction reads repunencrypt. The Edit
        // Transaction path supplies both via EditAccount(); without them the tab
        // renders empty when opened from Account Form Review.
        queryParams.Cld = options.clientId
        queryParams.repunencrypt = options.repId
        break
    }

    this.router.navigate(['/pages/TabsScreen/tab-views'], { queryParams })
  }

  private buildDefaultSearchFormValues() {
    return {
      blotterId: null,
      clientId: null,
      clientName: null,
      accountName: null,
      accountNumber: null,
      branchNumber: '',
      repId: null,
      repCode: null,
      statusTypeId: this.approvedStatusId,
      submittedStartDate: null,
      submittedEndDate: null,
      approvalStartDate: null,
      approvalEndDate: new Date(),
    }
  }

  // Run search once after relevant state (preferences or view state) is applied
  private maybeInitialSearch() {
    if (this.initialSearchPerformed) return
    // The status lookup resolves the Approved id and runs in ngOnInit, i.e.
    // after the constructor's preference/view-state subscriptions have already
    // fired (both are BehaviorSubjects and emit synchronously). Without this
    // gate the first search went out with statusTypeId = null and the grid came
    // back holding every status, not just Approved.
    if (!this.loadedStatuses) return
    // If a saved view state exists, prefer it and run immediately when loaded
    if (this.loadedViewState && this.hasViewState) {
      this.initialSearchPerformed = true
      this.getTransactionSearchResults(this.clientIdParam)
      return
    }
    // If no saved view state, run after preferences arrive
    if (this.loadedPreferences && this.loadedViewState && !this.hasViewState) {
      this.initialSearchPerformed = true
      this.getTransactionSearchResults(this.clientIdParam)
    }
  }

  /**
   * The Approved-only filter depends on resolving that status's id. If the
   * lookup fails we cannot enforce it, and silently listing every status on a
   * screen labelled "All Transactions ... Approved" would be misleading, so say
   * so rather than let the wrong rows through unannounced.
   */
  private showStatusLookupError() {
    this.toastrService.error(
      'Could not load the status list, so results may include transactions ' +
        'that are not Approved. Please refresh the page.',
      'Status filter unavailable',
    )
  }
}

export enum TransactionStatusEnum {
  RepProcessingPaperwork,
  BranchManagerReview,
  ProcessingPaperwork,
  SubmittedForReview,
  PendingPreliminaryReviewComplete,
  Approved,
  RejectedCaseClosed,
}
